import { useState } from "react";
import PageHeader from "../../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import InfoButton from "../../../../../components/Universal/InfoButton.component";
import ExamDetailsHeader from "../../../../../components/PagesComponents/Operational/Academic/Exams/ExamDetails/ExamDetailsHeader.component";
import ExamDetailsBodyForm from "../../../../../components/PagesComponents/Operational/Academic/Exams/ExamDetails/ExamDetailsBodyForm.component";
const Body = () => {
  // eslint-disable-next-line no-unused-vars
  const [examDetails, setExamDetails] = useState({
    examName: "First terminal examination",
    gender: "All",
    startDate: "27 Dec, 2024",
    endDate: "07 Jan, 2025",
    venue: "ABC boys class building",
    conductedBy: "School authority",
  });
  return (
    <div className="flex-col align-left justify-start g-1 w-full pr-1">
      <PageHeader title={`${examDetails?.examName} (${examDetails?.gender})`} />

      <div className="flex-col align-left justify-start g-2 radius-10 w-full">
        <div
          className="w-full flex-col align-left justify-start g-3 radius-10 back-white"
          style={{ padding: "32px 43px" }}
        >
          <ExamDetailsHeader data={examDetails && examDetails} />

          <ExamDetailsBodyForm />
        </div>

        {/* footer section */}
        <div className="flex-row align-center justify-between w-full">
          <div className="flex-row align-center justify-start g-05">
            <InfoButton />
            <span className="t-14 poppins-medium color-grayColor">
              Once you click on ‘Finished exam’ button, you add this exam in
              ‘All past examinations’ portion
            </span>
          </div>
          <div className="flex-row align-center justify-start g-1">
            <button className="deleteBtnFill pl-1 pr-1" type="button">
              Finished exam
            </button>
            <button className="actionBtn" type="button">
              Update changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Body;
